import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import TopicComponent from '../components/topic.component';
import { selectLMSTopicsListItems, selectLMSTopicsQueryItems } from '../../../../../../redux/lms/topics/selector';
import { lmsTopics } from '../../../../../../redux/lms/topics/action';

const ManagementLMSTopic = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const lmsTopicsQuery = useSelector(selectLMSTopicsQueryItems)
  const lmsTopicsItems = useSelector(selectLMSTopicsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedTopics, setSelectLMSTopics] = useState<any>(
    {
      "title": "",
      "description": "",
      "parentId": 0,
      "mappedTopics": {
        "mappedTopicIds": []
      },
      "mediaMappings": {
        "mediaFiles": [],
        "templates": []
      }
    }
  );

  const fetchLMSTopicsQueryById = () => {
    dispatch(lmsTopics.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/collections/query`,
      entity: 'lmsTopics',
      jsonData: {
        records: [
          {
            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSTopics({ ...selectedTopics, [field]: event })
  }

  useEffect(() => {
    dispatch(lmsTopics.list({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/topics/list`,
      entity: 'lmsTopics',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchLMSTopicsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSTopics(lmsTopicsQuery?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const selectedTopicsData =
    {
      "title": selectedTopics?.Title || '',
      "description": selectedTopics?.Description || '',
      "parentId": selectedTopics?.ParentId || 0,
      "mappedTopics": {
        "mappedTopicIds": []
      },
      "mediaMappings": {
        "mediaFiles": [],
        "templates": []
      }
    }
    if (parmas?.id > 0) {
      await dispatch(lmsTopics.resetAction({ actionType: 'update' }))
      await dispatch(lmsTopics.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/topics`,
        entity: 'lmsTopics',
        jsonData: {
          records: [
            selectedTopicsData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(lmsTopics.resetAction({ actionType: 'create' }))
      await dispatch(lmsTopics.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v1.0/e-applications/lms/topics`,
        entity: 'lmsTopics',
        jsonData: {
          records: [
            selectedTopicsData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/topics')
  }

  return (
    <>
      {lmsTopicsQuery?.isLoading ? <PageLoader /> :
        <TopicComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedTopics={selectedTopics}
          back={back}
          handleFormSubmit={handleFormSubmit}
          parentTopicsList={lmsTopicsItems?.result?.items}
        />
      }
    </>
  )
}

export default ManagementLMSTopic;